import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import StripeProvider from './components/payment/StripeProvider';
import { YearProvider } from './context/YearContext';
import ChunkErrorBoundary from './components/ChunkErrorBoundary';

// Handle chunk load errors that occur outside React
window.addEventListener('error', (event) => {
  if (
    event.message?.includes('Loading chunk') ||
    event.message?.includes('Failed to fetch dynamically imported module')
  ) {
    const hasRefreshed = sessionStorage.getItem('chunk_error_refreshed');
    if (!hasRefreshed) {
      sessionStorage.setItem('chunk_error_refreshed', 'true');
      window.location.reload();
    }
  }
});

// Handle unhandled promise rejections (dynamic imports return promises)
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason?.message?.includes('Failed to fetch dynamically imported module') ||
    event.reason?.message?.includes('error loading dynamically imported module')
  ) {
    const hasRefreshed = sessionStorage.getItem('chunk_error_refreshed');
    if (!hasRefreshed) {
      sessionStorage.setItem('chunk_error_refreshed', 'true');
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ChunkErrorBoundary>
      <AuthProvider>
        <StripeProvider>
          <YearProvider>
            <App />
          </YearProvider>
        </StripeProvider>
      </AuthProvider>
    </ChunkErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW registration failed — app still works normally
    });
  });
}
